import { jsx as _jsx } from "react/jsx-runtime";
import { Button as ChakraButton, forwardRef, } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Icon } from '@caspeco/casper-ui-library.components.icon';
import { getIconSizeFromButtonSize } from './button.helper';
/**
 * Button component is used to trigger an action or event,
 * such as submitting a form, opening a Dialog, canceling an action, or performing a delete operation.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/button
 * @see WAI-ARIA https://www.w3.org/WAI/ARIA/apg/patterns/button
 */
export const Button = forwardRef((props, ref) => {
    const { children, variant = 'secondary', size = 'md', href, isSelected, leftIcon, rightIcon, } = props;
    const iconSize = useMemo(() => getIconSizeFromButtonSize(size), [size]);
    // Display the button as a link element when href is provided
    if (href) {
        return (_jsx(ChakraButton, { as: "a", href: href, size: size, variant: variant, ...props, ref: ref, "aria-pressed": isSelected, leftIcon: leftIcon ? _jsx(Icon, { size: iconSize, icon: leftIcon }) : undefined, rightIcon: rightIcon ? _jsx(Icon, { size: iconSize, icon: rightIcon }) : undefined, children: children }));
    }
    // Else, regular button
    return (_jsx(ChakraButton, { size: size, variant: variant, ref: ref, ...props, "aria-pressed": isSelected, leftIcon: leftIcon ? _jsx(Icon, { size: iconSize, icon: leftIcon }) : undefined, rightIcon: rightIcon ? _jsx(Icon, { size: iconSize, icon: rightIcon }) : undefined, children: children }));
});
//# sourceMappingURL=button.js.map